<div class="pt-3" *ngIf="!myAccount.can_manage_events">
  <h2>You do not have permission to manage event settings.</h2>
</div>

<ng-container *ngIf="myAccount.can_manage_events">
  <div class="pt-4 pl-md-4" *ngIf="notFound">
    <h2>Event Settings Not Found</h2>
  </div>

  <div class="pt-4 pl-md-4" *ngIf="serverError !== null">
    <h2>Server Error: {{ serverError }}</h2>
  </div>

  <div class="pt-4 pl-md-4" *ngIf="!notFound && (serverError === null)">
    <div class="row">
      <div class="col">
        <p class="mt-2" style="width:100%;text-align:center"><b>EVENT SETTINGS</b></p>
      </div>
    </div>

    <div class="mb-5 border-rounded-10 p-4">

      <ng-container *ngIf="locationService.getNumLocations() !== 1">
        <div class="form-group">
          <div class="d-inline">
            <select class="custom-select col-xl-4 col-lg-6 col-md-8"
                    id="selectLocation" name="selectLocation"
                    [(ngModel)]="selectedLocationId"
                    (ngModelChange)="handleSelectLocation()"
                    [disabled]="isLoading()"
                    [class.disabled]="isLoading()">
              <option *ngIf="locationService.getLocations() === null">Loading...</option>
              <ng-container *ngIf="locationService.getLocations() !== null">
                <option *ngFor="let location of locationService.getLocations()"
                        [ngValue]="location.id">
                  {{ location.name }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>

        <hr>
      </ng-container>

      <form (submit)="onEventSettingsSubmit()">

        <div class="row">
          <div class="col-md-8 col-xl-6">

            <div class="form-group">
              <label for="landingPageTextArea">Event Landing Page Text</label>
              <textarea id="landingPageTextArea" type="text" rows="8"
                        class="form-control" name="landingPageText"
                        [(ngModel)]="location.scheduler_landing_page_text"></textarea>
              <div class="form-text text-danger">{{ eventSettingsErrors.scheduler_landing_page_text }}</div>
            </div>

            <div class="form-group" *ngIf="loadingEventSettings">
              <label for="firstDaySelectLoading">Scheduler Calendar First Day of Week</label>
              <select id="firstDaySelectLoading" class="custom-select" disabled>
                <option selected>Loading...</option>
              </select>
            </div>
            <div class="form-group" *ngIf="!loadingEventSettings">
              <label for="firstDaySelect">Scheduler Calendar First Day of Week</label>
              <select id="firstDaySelect" class="custom-select" name="firstDay"
                      [(ngModel)]="location.scheduler_first_day_of_week">
                <option value="{{ LocationSchedulerFirstDayOfWeek.sunday }}">Sunday</option>
                <option value="{{ LocationSchedulerFirstDayOfWeek.monday }}">Monday</option>
              </select>
              <div class="form-text text-danger">
                {{ eventSettingsErrors.scheduler_first_day_of_week }}
              </div>
            </div>

            <div class="form-group" *ngIf="loadingEventSettings">
              <label>
                Staff Site Events Page Default View
              </label>
              <select class="custom-select" disabled>
                <option selected>Loading...</option>
              </select>
            </div>
            <div class="form-group" *ngIf="!loadingEventSettings">
              <label for="default_staff_site_events_view">
                Staff Site Events Page Default View
              </label>
              <select id="default_staff_site_events_view"
                      class="custom-select"
                      name="default_staff_site_events_view"
                      [(ngModel)]="location.default_staff_site_events_view">
                <option value="{{ LocationDefaultStaffSiteEventsView.scheduledEventsList }}">Scheduled Events List View</option>
                <option value="{{ LocationDefaultStaffSiteEventsView.calendar }}">Calendar View</option>
              </select>
              <div class="form-text text-danger">
                {{ eventSettingsErrors.default_staff_site_events_view }}
              </div>
            </div>

          </div>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="eventSettingsErrors.non_field_errors">
          {{ eventSettingsErrors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="eventSettingsErrorMessage">
          {{ eventSettingsErrorMessage }}
        </div>

        <div class="alert alert-info" role="alert" *ngIf="loadingEventSettings">
          Loading...
        </div>

        <div class="alert alert-success" role="alert" *ngIf="eventSettingsSuccessMessage">
          {{ eventSettingsSuccessMessage }}
        </div>

        <!-- Place save button first so that the enter key press activates it -->
        <div class="float-right">
          <button type="submit" class="btn btn-primary mr-2"
                  [disabled]="isLoading()" [class.disabled]="isLoading()">
            Save
          </button>
        </div>
        <button type="button" class="btn btn-secondary"
                (click)="loadLocation()"
                [disabled]="isLoading()" [class.disabled]="isLoading()">
          Cancel
        </button>

      </form>

      <hr>

      <h3>Blackout Dates</h3>

      <p>No scheduled events will be created on the configured blackout dates. This only applies to regular event schedules; schedule exceptions and multi-part/one-off occurrences are not affected.</p>

      <div class="alert alert-danger" *ngIf="blackoutDatesErrorMessage">
        {{ blackoutDatesErrorMessage }}
      </div>

      <div class="alert alert-success" *ngIf="blackoutDatesSuccessMessage">
        {{ blackoutDatesSuccessMessage }}
      </div>

      <div class="alert alert-info" *ngIf="loadingEditBlackoutDates">
        Loading...
      </div>

      <table class="mb-3">
        <tr *ngFor="let blackoutDate of blackoutDates; let idx = index;" style="border-bottom: 4px solid white">
          <td><b>{{ dateStringFromISO8601(blackoutDate) }}</b></td>
          <td class="pl-2">
            <button class="btn btn-sm btn-danger"
                    [disabled]="loadingEditBlackoutDates"
                    [class.disabled]="loadingEditBlackoutDates"
                    (click)="removeBlackoutDate(idx)">
              Remove
            </button>
          </td>
        </tr>
        <tr *ngIf="blackoutDates.length === 0">
          <td colspan="99" class="text-muted">
            <span *ngIf="loadingBlackoutDates">Loading...</span>
            <span *ngIf="!loadingBlackoutDates">No blackout dates configured</span>
          </td>
        </tr>
      </table>

      <form class="form-inline" (ngSubmit)="addBlackoutDate()">
        <div class="form-group">
          <div class="mr-2">
            <app-date-picker [id]="'newBlackoutDateInput'"
                               [(content)]="newBlackoutDateInput"></app-date-picker>
          </div>

          <button class="btn btn-primary" type="submit"
                  [disabled]="loadingEditBlackoutDates || !blackoutDateInputValid()"
                  [class.disabled]="loadingEditBlackoutDates || !blackoutDateInputValid()">
            Add Blackout Date
          </button>
        </div>
      </form>

    </div>
  </div>
</ng-container>
